import { render, staticRenderFns } from "./BasicCustomerInquiryReg.vue?vue&type=template&id=0c72bd6d&scoped=true"
import script from "./BasicCustomerInquiryReg.vue?vue&type=script&lang=js"
export * from "./BasicCustomerInquiryReg.vue?vue&type=script&lang=js"
import style0 from "./BasicCustomerInquiryReg.vue?vue&type=style&index=0&id=0c72bd6d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72bd6d",
  null
  
)

export default component.exports